import { memo } from 'react';

import { SvgProps } from '@/types';

export const LogoImg = memo(({ ...rest }: SvgProps | any) => (
  <svg fill="currentColor" fillRule="evenodd" viewBox="0 0 1024 1024" {...rest}>
    <path
      d="M787.2 340C765.6 210.4 650.4 112 512 112S258.4 210.4 236.8 340C102.4 360 0 472.8 0 608.8c0 142.4 112.8 258.4 256 270.4l12.8-89.6c-97.6-4.8-175.2-84.8-175.2-180.8 0-100 83.2-180.8 184-180.8h47.2v-44.8c1.6-98.4 84.8-179.2 185.6-179.2 102.4 0 185.6 80.8 185.6 179.2v44.8h47.2c102.4 1.6 184 81.6 184 180.8 0 96-78.4 175.2-175.2 180.8l12.8 89.6c144.8-11.2 258.4-129.6 258.4-270.4 0.8-136-101.6-248.8-236-268.8z"
      fill="#4461EB"
    />
    <path
      d="M395.2 880h-93.6l59.2-430.4h80.8L395.2 880z m326.4 0h-93.6l-46.4-430.4h80.8l59.2 430.4z"
      fill="#29DD90"
    />
    <path d="M372.8 699.2h279.2v91.2h-279.2V699.2z m0-158.4h279.2v68h-279.2v-68z" fill="#29DD90" />
  </svg>
));
